import * as ActionTypes from "constants/ActionTypes";
import * as InactivityKey from "utils/interfaces/InactivityKey";
import { combineReducers } from "redux";

function controls(state = false, action) {
  if (
    action.type === ActionTypes.SET_INACTIVITY &&
    action.key === InactivityKey.CONTROLS
  ) {
    return action.value;
  }

  return state;
}

function interviewSidebar(state = false, action) {
  if (
    action.type === ActionTypes.SET_INACTIVITY &&
    action.key === InactivityKey.INTERVIEW_SIDEBAR
  ) {
    return action.value;
  }

  return state;
}

function loopingVideos(state = false, action) {
  if (
    action.type === ActionTypes.SET_INACTIVITY &&
    action.key === InactivityKey.LOOPING_VIDEOS
  ) {
    // Temporarily ignore looping video inactivity due to Android S21 bug.

    // return action.value;
    return false;
  }

  return state;
}

function compactControls(state = false, action) {
  if (
    action.type === ActionTypes.SET_INACTIVITY &&
    action.key === InactivityKey.COMPACT_CONTROLS
  ) {
    return action.value;
  }

  return state;
}

function isTransitioning(state = false, action) {
  if (action.type === ActionTypes.SET_TRANSITIONING) {
    return action.value;
  }
  return state;
}

export default combineReducers({
  compactControls,
  controls,
  interviewSidebar,
  loopingVideos,
  isTransitioning,
});
